import * as React from 'react';

const CurrencyIllustrationSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 364.4 700" {...props}>
        <style>
            {
                '\n        .currency-illustration_svg__st1{fill:#f05537}.currency-illustration_svg__st2{fill:#1e0a3c}.currency-illustration_svg__st3{fill:#324b8c}.currency-illustration_svg__st4{fill:#fff}\n    '
            }
        </style>
        <path d="M0 674.2C550.9 567 389.3 36.8 0 31.1v643.1z" fill="#dbdae3" />
        <path
            className="currency-illustration_svg__st1"
            d="M177.9 424.4c5.3-3.8 28-12 32.3-13.9 4.3-1.8 22.2.2 33.3-.9 11-1.1 13.6-20.1 5.3-21.1s-35.7-4.6-43.5-3.5c-7.8 1.1-41.8 12-47.7 14.1-5.9 2.1-32.3 26.8-33.7 25-1.4-1.8 9.4-20.9 12.1-26.7 2.6-5.8 24.8-29.3 27.6-32.2 2.8-2.9 8.4-3.2 20.7-8.1 12.3-4.9 15.6-26.6 5.8-25-9.9 1.6-26.8 2.3-34.3 6.1-43.4 21.7-66.8 66.4-82.8 91-10.7 16.5-46.6 105.4-53.3 117.4-2.1 3.7-9.9 15.9-19.7 31v98.2l36 10s20.9-76.4 29.3-81.3c9.2-5.4 17.4-6.5 35.9-20.8s28.9-41.9 31.9-47.7 17.2-19.2 21.4-23.2 17-6.3 25.4-9.1c8.4-2.8 18.3 2.5 25.6 9.3 7.2 6.8 21.5 2.9 17.8-4.7-3.7-7.5-10.8-19.8-14.1-22.8-3.3-3.1-20.8-4.5-24.4-4.2-3.6.3-23.8 2.7-24.1 1.5-.4-1.6 28-6.4 34.3-5.6s13.2 4.7 26.3 16.7c13.1 12 27.2 1.2 23.2-5.7s-14.7-23.1-19.4-26.8c-4.7-3.8-29.4-14.3-37.3-15.2-7.9-1-38.5 11.5-40.2 5.7-1.7-5.8 25-23.7 30.3-27.5z"
        />
        <path
            className="currency-illustration_svg__st2"
            d="M0 344.5L204.9 169 117.1 66.9 0 167.2z"
        />
        <path
            className="currency-illustration_svg__st3"
            d="M174.3 151.2l-43.2-50.3h-.1c-9.2 7.9-22.9 6.8-30.8-2.3L0 184.3v124.3c5.6.4 11.1 2.9 15.1 7.5L172 182c-7.9-9.3-6.9-23 2.3-30.8z"
        />
        <path
            className="currency-illustration_svg__st2"
            d="M0 366l197.9-130.5-74.6-112.6L0 204.2z"
        />
        <path
            className="currency-illustration_svg__st1"
            d="M248.8 311.2l62-.4c3.6 0 6.6 2.9 6.6 6.5l.8 119.5c0 4.2-3.4 7.6-7.6 7.6l-60.6.5"
        />
        <path
            className="currency-illustration_svg__st4"
            d="M249.7 332.2l67.8-.5.2 28.4-68.2.4M301.5 413.5l-51.5.4v-8.8l51.5-.4v8.8z"
        />
        <path
            className="currency-illustration_svg__st3"
            d="M168.5 213.8l-36.6-55.3h-.1c-10 6.7-23.6 3.9-30.3-6.1L0 219.4v131.7L162.3 244c-6.7-10.1-3.9-23.5 6.2-30.2z"
        />
        <ellipse
            transform="rotate(-33.981 55.192 252.595)"
            className="currency-illustration_svg__st2"
            cx={55.2}
            cy={252.6}
            rx={33.2}
            ry={38.3}
        />
        <path
            d="M198.7 502.9c-1.4 0-2.5 1.2-2.5 2.5 0 1.4 1.2 2.5 2.5 2.5 1.4 0 2.5-1.2 2.5-2.5 0-1.5-1.1-2.5-2.5-2.5m-3.3 2.4c0-1.8 1.5-3.3 3.3-3.4 1.8 0 3.3 1.5 3.4 3.3 0 1.8-1.5 3.3-3.3 3.4-1.8.1-3.4-1.4-3.4-3.3z"
            fill="#9b9ea7"
        />
        <path
            className="currency-illustration_svg__st3"
            d="M246 491.3c0 .8-.7 1.5-1.4 1.5l-128.9.6c-.8 0-1.5-.7-1.5-1.4l-1.1-230.7c0-.8.7-1.5 1.4-1.5l128.9-.6c.8 0 1.5.7 1.5 1.4l1.1 230.7"
        />
        <path
            className="currency-illustration_svg__st4"
            d="M248 444l-136.6.9-.9-133.7 136.4-.9"
        />
        <path
            className="currency-illustration_svg__st1"
            d="M247.6 359.6l-136.8.8-.2-28.4 137.1-.9"
        />
        <circle cx={148.2} cy={408.8} fill="#f6682f" r={12.7} />
        <circle
            className="currency-illustration_svg__st2"
            cx={131.7}
            cy={409.3}
            r={12.7}
        />
        <path
            className="currency-illustration_svg__st1"
            d="M245 413.5l-57.9.4v-8.8l57.9-.4v8.8z"
        />
        <path
            className="currency-illustration_svg__st2"
            d="M127.3 518l105.3-.5c9.8-.1 17.7-8 17.6-17.7L248.9 251c-.1-9.7-8-17.6-17.8-17.6l-105.3.6c-9.8.1-17.7 8-17.6 17.7l1.2 248.9c.1 9.7 8 17.5 17.9 17.4zm-11.8-25.1c-.8.1-1.5-.6-1.4-1.5L113 261.5c0-.8.7-1.5 1.4-1.5l128.4-.6c.8 0 1.5.7 1.5 1.4l1 229.9c0 .8-.7 1.5-1.4 1.5l-128.4.7z"
        />
        <circle
            className="currency-illustration_svg__st4"
            cx={234.6}
            cy={271.2}
            r={1.7}
        />
        <circle
            className="currency-illustration_svg__st4"
            cx={234.6}
            cy={276.9}
            r={1.7}
        />
        <circle
            className="currency-illustration_svg__st4"
            cx={234.6}
            cy={282.7}
            r={1.7}
        />
        <path
            className="currency-illustration_svg__st1"
            d="M47.9 700c6.9-20 25.4-72.7 30.6-79.3 6.4-8.2 37.1-23.6 50.3-41.4 13.2-17.8 15.6-41 20.2-47.5s23-13.2 30.9-18.4c16.7-10.9 40-34.3 30.9-50-4.6-8-16.3-.7-21.8 2.4-35.3 20.3-62 32.4-85.1 39.3-23.1 6.9-55.1 42.6-63.6 56.9L0 640v60h47.9z"
        />
        <g>
            <path
                className="currency-illustration_svg__st2"
                d="M62 530c-.3.1-.5 0-.7-.2-.4-.4-.5-.9-.1-1.3 8.2-7.3 20.4-16.8 31.3-20 6.3-2 17.2-5.9 21.3-8.9.4-.1.6-.1.9.1.4.3.5.9.2 1.3-4.6 3.5-16.3 7.5-21.8 9.2-10.5 3.1-22.5 12.4-30.7 19.6-.1.1-.3.2-.4.2z"
            />
        </g>
    </svg>
);

CurrencyIllustrationSvg.displayName = 'CurrencyIllustrationSvg';
export default CurrencyIllustrationSvg;
